import night from './night'
import day from './day'
import bg from './bg'
import bearDonor from './bearDonor'
import bearWpd from './bearWpd'

const tlNight = night
const tlDay = day
const tlBg = bg
const tlBearDonor = bearDonor
const tlBearWpd = bearWpd

export {
  tlNight,
  tlDay,
  tlBg,
  tlBearDonor,
  tlBearWpd
}



// WEBPACK FOOTER //
// ./src/mixins/timelines/index.js